import { cn } from "@/lib/utils";
import Image from "next/image";

const ANIMATION_TEXTURE_SRC = "/assets/steam-onboarding/animation-texture.webp";
const ANIMATION_MASK_SRC = "/assets/steam-onboarding/animation-mask.svg";

const animationMaskStyle = {
  maskImage: `url('${ANIMATION_MASK_SRC}')`,
  WebkitMaskImage: `url('${ANIMATION_MASK_SRC}')`,
  maskSize: "contain",
  maskPosition: "center",
  maskRepeat: "no-repeat",
};

const getAnimationTintStyle = (tint: string) => ({
  mixBlendMode: "hue",
  backgroundColor: tint,
});

export const AnimatedEffect = ({
  className = "",
  tint,
}: {
  className?: string;
  tint: string;
}) => {
  return (
    <>
      <div
        className={cn("relative w-full h-full mask", className)}
        // tailwind v3 doesnt support mask properties :sadge:
        style={animationMaskStyle}
      >
        <Image
          src={ANIMATION_TEXTURE_SRC}
          alt=""
          width={200}
          height={200}
          // gif, animated png/webp not supported by next/image
          unoptimized
          className="w-full h-full"
        />
        <div
          className="absolute inset-0"
          style={getAnimationTintStyle(tint) as React.CSSProperties}
        />
      </div>
    </>
  );
};
